<template>
  <ConfirmationModal
    :bodyText="bodyText"
    :cancelText="cancelText"
    :continueText="continueText"
    :enableMainAction="inputValid"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    :headerText="headerText"
    :kbLink="kbLink"
    :kbLinkText="kbLinkText"
    :loading="loading"
    :showClose="showClose"
  >
    <p v-if="additionalText">
      {{ additionalText }}
    </p>
    <ConfirmationInput
      :config="confirmationInputConfig"
      :defaultValue="defaultInputValue"
      @input="handleChangeEvent($event)"
    />
  </ConfirmationModal>
</template>
<script>

import ConfirmationInput from 'client/components/Modal/ModalComponents/ConfirmationInput.vue';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  name: 'EmailConfirmationModal',

  inject: ['$validator'],

  components: {
    ConfirmationInput,
    ConfirmationModal,
  },

  ModalEventBus,

  props: {
    additionalText: {
      default: '',
      type: String,
    },
    bodyText: {
      default: '',
      type: String,
    },
    cancelText: {
      default: 'cancel',
      type: String,
    },
    confirmationText: {
      default: 'Email Destination',
      type: String,
    },
    defaultInputValue: {
      default: '',
      type: String,
    },
    handleCancel: {
      type: Function,
      default: () => this.$options.ModalEventBus.close(),
    },
    handleContinue: {
      type: Function,
      default: () => this.$options.ModalEventBus.close(),
    },
    headerText: {
      default: 'Email Confirmation',
      type: String,
    },
    loading: Boolean,
    readOnlyInput: Boolean,
  },

  data() {
    // @todo CONVERT ANY OF THIS TO PROPS WHEN NEEDED
    return {
      confirmationInputConfig: {
        confirmationText: this.confirmationText,
        emailCustomMessage: 'Enter a valid email address',
        name: 'activation_email',
        readonly: this.readOnlyInput,
        requiredCustomMessage: 'An activation email is required',
        style: {
          boldLabel: true,
          inputSpacing: true,
        },
        validationRule: 'required|email',
      },
      continueText: 'send',
      inputValid: false,
      kbLink: KbArticleUrls.emailCustomization,
      kbLinkText: 'Learn how to customize email templates',
      showClose: false,
    };
  },

  mounted() {
    this.handleChangeEvent(this.defaultInputValue);
  },

  methods: {
    async handleChangeEvent(val) {
      await this.$validator.validate(this.confirmationInputConfig.name);
      this.inputValid = (this.v2Errors.items.length === 0);
      this.$emit('input', val);
    },
  },
};
</script>
